import {Stack} from '@mui/material';
import {useQuery} from 'react-query';
import {useSearchParams} from 'react-router-dom';
import TableWrapper from 'src/components/wrappers/TableWrapper';
import {LoadingView} from 'src/routes';
import {request} from 'src/utils/AdminApi';
import Pagination from 'src/components/Pagination';
export default function DynamicList({
	api_route,
	transformData,
	RowComponent,
	cols,
	parent,
	usePagination = false,
	searchParam = 'search',
	onRowClick,
}) {
	const [searchParams] = useSearchParams();

	// Build route with all query parameters
	const buildRoute = () => {
		const params = new URLSearchParams();

		// Add pagination if enabled
		if (usePagination) {
			const page = searchParams.get('page') || '1';
			params.set('page', page);
		}

		// Add search parameter if exists
		const searchValue = searchParams.get(searchParam);
		if (searchValue) {
			params.set(searchParam, searchValue);
		}

		const queryString = params.toString();
		return queryString ? `${api_route}?${queryString}` : api_route;
	};

	const route = buildRoute();
	let {data, isLoading, refetch, error} = useQuery(route, () => request(route));

	function getResults() {
		if (!data) return [];
		if (typeof transformData === 'function') {
			return transformData(data);
		}
		if (usePagination) {
			return data.data || [];
		} else {
			return data;
		}
	}

	const results = getResults();
	const paginationData = data?.pagination || null;
	const renderList = () => {
		if (!RowComponent) {
			if (cols) {
				return <TableWrapper headerColumns={cols} data={results} onRowClick={onRowClick} />;
			} else {
				return null;
			}
		} else {
			if (parent) {
				return (
					<parent.Component {...parent.props}>
						{results.map((item, index) => (
							<RowComponent
								key={item.id ?? index}
								item={item}
								refetch={refetch}
								onRowClick={onRowClick}
							/>
						))}
					</parent.Component>
				);
			} else {
				return (
					<Stack spacing={2}>
						{results.map((item, index) => (
							<RowComponent
								key={item.id ?? index}
								item={item}
								refetch={refetch}
								onRowClick={onRowClick}
							/>
						))}
					</Stack>
				);
			}
		}
	};
	return (
		<div>
			{error && (
				<div>
					{error.message ?? 'حدث خطا غير متوقع'}
					<button
						onClick={() => {
							refetch();
						}}
					>
						اعادة المحاولة
					</button>
				</div>
			)}

			{isLoading && (
				<div>
					<LoadingView />
				</div>
			)}

			{!isLoading && results?.length === 0 && <div>لا يوجد نتائج</div>}

			{results?.length > 0 && renderList()}

			{usePagination && paginationData && <Pagination pagination={paginationData} />}
		</div>
	);
}
